<template>
<div class="auth-wrap">
    <div class="auth-card auth-card--wide glass">
        <div class="auth-brand">
            <span class="brand__logo">&lt;/&gt;</span>
            <span class="brand">Entrance Exam</span>
        </div>
        <h1 class="auth-title">Create your account</h1>
        <p class="auth-sub">Register as an examinee and try the sample assessment.</p>

        <div class="field">
            <label for="reg-name">Name</label>
            <input id="reg-name" type="text" class="input" placeholder="Your full name"
                :class="{'is-invalid': isNameValid===false, 'is-valid': isNameValid===true}"
                v-model="form.name" @input="onNameInput" autocomplete="name">
            <div v-if="isNameValid!=null && !isNameValid">
                <p class="err" v-if="!$v.form.name.required">Name is required</p>
                <p class="err" v-else-if="!$v.form.name.minLength">Name should have at least 3 letters</p>
            </div>
        </div>

        <div class="field">
            <label for="reg-email">Email</label>
            <input id="reg-email" type="email" class="input" placeholder="you@example.com"
                :class="{'is-invalid': isEmailValid===false, 'is-valid': isEmailValid===true}"
                v-model="form.email" @input="onEmailInput" autocomplete="email">
            <div v-if="isEmailValid!=null && !isEmailValid">
                <p class="err" v-if="!$v.form.email.required">Email is required</p>
                <p class="err" v-else-if="!$v.form.email.email">Invalid email</p>
            </div>
        </div>

        <div class="field">
            <label for="reg-password">Password</label>
            <input id="reg-password" type="password" class="input" placeholder="Min 8 chars, mixed case, number, symbol"
                :class="{'is-invalid': isPasswordValid===false, 'is-valid': isPasswordValid===true}"
                v-model="form.password" @input="onPasswordInput" autocomplete="new-password">
            <div v-if="isPasswordValid!=null && !isPasswordValid">
                <p class="err" v-if="!$v.form.password.required">Password is required</p>
                <p class="err" v-else-if="!$v.form.password.minLength">Password must have at least 8 characters</p>
                <p class="err" v-else-if="!$v.form.password.containsUppercase">Password must have at least one uppercase letter</p>
                <p class="err" v-else-if="!$v.form.password.containsLowercase">Password must have at least one lowercase letter</p>
                <p class="err" v-else-if="!$v.form.password.containsNumber">Password must have at least one number</p>
                <p class="err" v-else-if="!$v.form.password.containsSpecial">Password must have at least one special character</p>
            </div>
        </div>

        <div class="field">
            <label for="reg-confpass">Confirm Password</label>
            <input id="reg-confpass" type="password" class="input" placeholder="Repeat your password"
                :class="{'is-invalid': isConfPassValid===false, 'is-valid': isConfPassValid===true}"
                v-model="form.confPass" @input="onConfPasswordInput" autocomplete="new-password"
                @keyup.enter="registerUser">
            <div v-if="isConfPassValid!=null && !isConfPassValid">
                <p class="err" v-if="!$v.form.confPass.required">Confirm password is required</p>
                <p class="err" v-else-if="!$v.form.confPass.isSame">Passwords do not match</p>
            </div>
        </div>

        <button class="btn btn--primary" style="width:100%" @click="registerUser" :disabled="status=='LOADING'">
            <span class="spinner spinner--dark" v-if="status=='LOADING'"></span>
            <span v-else>Create Account</span>
        </button>

        <p class="auth-alt">Already registered? <a href="/login">Sign in here</a></p>
    </div>
</div>
</template>
<script>
import Vue from 'vue'
import {registerUser} from '../services/users'
import {required, minLength, email} from 'vuelidate/lib/validators'
import router from '@/router'
    export default {
        name: 'RegisterPage',
        data() {
            return {
                status: '',
                form: {
                    name: '',
                    email: '',
                    password: '',
                    confPass: ''
                },
                isEmailValid: null,
                isPasswordValid: null,
                isNameValid: null,
                isConfPassValid: null
            }
        },
        methods: {
            onEmailInput () {
                this.isEmailValid = !this.$v.form.email.$invalid;
            },
            onPasswordInput () {
                this.isPasswordValid = !this.$v.form.password.$invalid;
            },
            onNameInput () {
                this.isNameValid = !this.$v.form.name.$invalid;
            },
            onConfPasswordInput () {
                this.isConfPassValid = !this.$v.form.confPass.$invalid;
            },
            async registerUser(){
                const credentials = {
                    name: this.form.name,
                    email: this.form.email,
                    password: this.form.password
                }
                if (!this.$v.form.$invalid)
                {
                    this.status = 'LOADING';
                    try{
                    const user = await registerUser(credentials);
                    this.status = 'LOADED';
                    Vue.$toast.success(''+user.data.name +' Registered Successfully');
                    router.push('./login')
                } catch(error){
                    Vue.$toast.error(error.message);
                    this.status = 'ERROR';
                }
                }

                else {
                    this.status = 'ERROR';
                    Vue.$toast.error('Invalid Credentials');
                }

            }
        },
        validations: {
            form: {
                name: {
                    required,
                    minLength: minLength( 3 )
                },
                email: {
                    email,
                    required
                },
                password: {
                    required,
                    minLength: minLength( 8 ),
                    containsUppercase: function(value) {
                        return /[A-Z]/.test(value)
                    },
                    containsLowercase: function(value) {
                        return /[a-z]/.test(value)
                    },
                    containsNumber: function(value) {
                        return /[0-9]/.test(value)
                    },
                    containsSpecial: function(value) {
                        return /[#?!@$%^&*-]/.test(value)
                    }
                },
                confPass: {
                    required,
                    isSame: function () {
                        return this.form.password == this.form.confPass;
                    }
                }
            }
        }
    }
</script>
